module.exports = __webpack_public_path__ + "media/images/icons/checkmark--stroke-51a335184efee5aba816fa481227ce18.svg";